import toast from "react-hot-toast";
import I18n, { i18n } from "../pages/private/languageSelector";
import { Storage } from "react-jhipster";
import moment from "dayjs";

export const normalizeForm = (form) => {
  if (form.selectedElement?.pageNo !== undefined && form.selectedElement?.sectionNo !== undefined && form.selectedElement?.questionNo !== undefined) {
    return form;
  }

  // fallback to first valid question
  const pageNo = 0;
  const sectionNo = 0;
  const questionNo = form.schema?.pages?.[0]?.sections?.[0]?.questions?.length > 0 ? 0 : undefined;

  return {
    ...form,
    selectedElement: questionNo !== undefined ? { pageNo, sectionNo, questionNo } : undefined,
  };
};

export const formatDateToArabic = (dateString, language, options) => {
  const date = new Date(dateString);

  if (language === "ENGLISH") {
    return date.toLocaleDateString("en", options);
  } else {
    return date.toLocaleDateString("ar", options);
  }
};

export const formatTimeToArabic = (timeString, language, options) => {
  const [hours, minutes] = timeString.split(":");
  const date = new Date();
  date.setHours(Number(hours));
  date.setMinutes(Number(minutes));

  if (language === "ENGLISH") {
    return date.toLocaleTimeString("en", options);
  } else {
    return date.toLocaleTimeString("ar", options);
  }
};
export const formatDateToTime = (timeString, language, options) => {
  const date = new Date(timeString);

  if (language === "ENGLISH") {
    return date.toLocaleTimeString("en", options);
  } else {
    return date.toLocaleTimeString("ar", options);
  }
};

export const ADD_ZEROES = (num) => {
  let value = Number(num);
  let res = num.split(".");
  if (res[1]?.length && res[1]?.length > 2) {
    value = value.toFixed(2);
  }
  return value;
};

export const truncateText = (str, maxLength) => {
  if (typeof str !== "string") {
    return "";
  }

  if (str.length > maxLength) {
    return str.substring(0, maxLength) + "...";
  }
  return str;
};

export const ReportStatusHandler = (status) => {
  if (status === "draft") {
    return <I18n lng="Reports.Draft" />;
  } else if (status === "incomplete") {
    return <I18n lng="Reports.InComplete" />;
  } else if (status === "reSubmit") {
    return <I18n lng="Reports.Resubmitted" />;
  } else if (status === "submit") {
    return <I18n lng="Reports.Submitted" />;
  } else if (status === "accept") {
    return <I18n lng="Reports.Approved" />;
  } else if (status === "reject") {
    return <I18n lng="Reports.Rejected" />;
  }
};

export const ReportStatusColorHandler = (status) => {
  if (status === "draft") {
    return "#828282";
  } else if (status === "incomplete") {
    return "#F2994A";
  } else if (status === "reSubmit") {
    return "#20639B";
  } else if (status === "submit") {
    return "#20639B";
  } else if (status === "accept") {
    return "#3CAEA3";
  } else if (status === "reject") {
    return "#EB5757";
  }
};

export const replacingObjectInArray = (orignalArray, arrayYouWantToAddedInOrignalArray) => {
  let result;
  result = arrayYouWantToAddedInOrignalArray.reduce(function (arr1, arr2) {
    let isMatchFound = false;
    arr1.forEach(function (list) {
      if (arr2.id === list.id) {
        list = Object.assign(list, arr2);
        isMatchFound = true;
      }
    });
    if (!isMatchFound) {
      arr1.push(arr2);
    }
    return arr1;
  }, orignalArray);
  if (result && result.length) {
    return result;
  }
};
export const colorMap = {
  "theme-gray-one": "#333333",
  "theme-gray-two": "#4F4F4F",
  "theme-gray-three": "#828282",
  "theme-primary-one": "#20639B",
  "theme-primary-two": "#2D9CDB",
  "theme-primary-three": "#56CCF2",
  "theme-green-one": "#219653",
  "theme-green-two": "#27AE60",
  "theme-green-three": "#6FCF97",
  "theme-red": "#EB5757",
  "theme-orange": "#F2994A",
  "theme-yellow": "#F2C94C",
  "theme-purple-one": "#9B51E0",
  "theme-purple-two": "#BB6BD9",
  "theme-pink": "#EAACCA",
};

export const reportThemeColor = (reportTheme) => {
  switch (reportTheme) {
    case "#333333":
      return "51, 51, 51";
    case "#4F4F4F":
      return "79, 79, 79";
    case "#828282":
      return "130, 130, 130";
    case "#20639B":
      return "32, 99, 155";
    case "#2D9CDB":
      return "45, 156, 219";
    case "#56CCF2":
      return "86, 204, 242";
    case "#219653":
      return "33, 150, 83";
    case "#27AE60":
      return "39, 174, 96";
    case "#6FCF97":
      return "111, 207, 151";
    case "#EB5757":
      return "235, 87, 87";
    case "#F2994A":
      return "242, 153, 74";
    case "#F2C94C":
      return "242, 201, 76";
    case "#9B51E0":
      return "155, 81, 224";
    case "#bb6bd9":
      return "187, 107, 217";
    case "#BB6BD9":
      return "234, 172, 202";
    default:
      return "32, 99, 155"; // fallback
  }
};

export const hexToRgb = (hex) => {
  if (typeof hex !== "string" || hex.length !== 7 || !/^#[0-9A-Fa-f]{6}$/.test(hex)) {
    // Missing / invalid color (e.g. a company with no report theme set). Fall back
    // to the default theme color instead of erroring out and returning black —
    // this is the "Invalid hex color: undefined" noise seen on /management/info.
    hex = "#20639b";
  }

  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);

  return { r, g, b };
};

export const lightenColor = (color, percent = 0.2) => {
  const colorObj = hexToRgb(color);
  const r = Math.round(colorObj.r + (255 - colorObj.r) * percent);
  const g = Math.round(colorObj.g + (255 - colorObj.g) * percent);
  const b = Math.round(colorObj.b + (255 - colorObj.b) * percent);
  return `rgb(${r}, ${g}, ${b})`;
};

export const mandatoryQuestionHandler = (schema, getAnswer, setMandatoryIds, setMandatoryQuestions) => {
  let mandatoryQuestions = 0;
  let mandatoryQuestionsIds = [];

  if (schema && schema.pages?.length) {
    schema?.pages?.map((page, pageIndex) =>
      page?.sections?.map((section, sectionIndex) => {
        return section?.questions?.map((question, questionIndex) => {
          const answer = getAnswer(question.questionUuid);
          // checking if question is answered or not
          return getAnswer(question.questionUuid) === undefined ||
            (question?.type !== "COMPLEX_MULTIPLE_CHOICE" &&
              (answer?.value === "" ||
                answer?.value === false ||
                (question?.type === "slider" && answer?.sliderValue === "") ||
                (question?.type === "slider" && answer?.sliderValue === undefined) ||
                (question?.type === "signature" && answer?.signature.length === 0) ||
                (question?.type === "DROPDOWN" && answer?.value === undefined) ||
                (question?.type === "image" && answer?.inspectorImages?.length < 1) ||
                answer?.address === "" ||
                answer?.inspectorImages?.length === 0 ||
                answer?.pdfPreview === "")) ||
            (question?.type === "COMPLEX_MULTIPLE_CHOICE" && answer?.selected?.length === 0)
            ? question?.settings?.isMandatory
              ? // if question is not answered and is mandatory add to the list
                ((mandatoryQuestions += 1),
                mandatoryQuestionsIds.push({
                  id: question.questionUuid,
                  pageIndex,
                  sectionIndex,
                  questionIndex,
                  question,
                }))
              : null
            : // checking if queston is answered and have a mandatory photo or comment
              question?.type !== "COMPLEX_MULTIPLE_CHOICE" &&
                ((question?.settings?.canComment && getAnswer(question.questionUuid)?.note === "") ||
                  (question?.settings?.canAttachPhoto && getAnswer(question.questionUuid).image.length === 0) ||
                  (question?.settings?.canComment &&
                    question?.settings?.canAttachPhoto &&
                    getAnswer(question.questionUuid)?.note === "" &&
                    getAnswer(question.questionUuid).image.length === 0))
              ? ((mandatoryQuestions += 1),
                mandatoryQuestionsIds.push({
                  id: question.questionUuid,
                  pageIndex,
                  sectionIndex,
                  questionIndex,
                  question,
                }))
              : question?.type === "COMPLEX_MULTIPLE_CHOICE" &&
                  ((getAnswer(question.questionUuid)?.selected?.some((item) => question.settings.answers[item.index]?.canComment) &&
                    getAnswer(question.questionUuid).note === "") ||
                    (getAnswer(question.questionUuid)?.selected.some((item) => question.settings.answers[item.index]?.canAttachPhoto) &&
                      getAnswer(question.questionUuid).image.length === 0))
                ? ((mandatoryQuestions += 1),
                  mandatoryQuestionsIds.push({
                    id: question.questionUuid,
                    pageIndex,
                    sectionIndex,
                    questionIndex,
                    question,
                  }))
                : null;
        });
      }),
    );
  }
  setMandatoryQuestions(mandatoryQuestions);
  setMandatoryIds(mandatoryQuestionsIds);
};

export const mandatoryAnswerHandler = (getAnswer, mandatoryIds, mandatoryQuestions, setMandatoryAnswered) => {
  let answered = 0;

  mandatoryIds.forEach((item) => {
    return getAnswer(item.id) !== undefined
      ? item?.question?.type !== "COMPLEX_MULTIPLE_CHOICE" &&
        item?.question?.settings?.canComment &&
        getAnswer(item.id).note !== "" &&
        item?.question?.settings?.canAttachPhoto &&
        getAnswer(item.id).image?.length
        ? (answered += 1)
        : item?.question?.type === "COMPLEX_MULTIPLE_CHOICE" &&
            item?.question?.settings?.answers[getAnswer(item?.question.questionUuid)?.selected[0]?.index]?.canComment &&
            getAnswer(item.id).note !== "" &&
            item?.question?.settings?.answers[getAnswer(item?.question.questionUuid)?.selected[0]?.index]?.canAttachPhoto &&
            getAnswer(item.id).image?.length
          ? (answered += 1)
          : null
      : null;
  });
  setMandatoryAnswered(answered);
  if (mandatoryQuestions === answered) return true;
  if (mandatoryQuestions !== answered) return false;
};

export const navigatingToQuestion = (mandatoryIds, getAnswer) => {
  let unAnswered = [];

  mandatoryIds.forEach((item) => {
    return getAnswer(item.id) === undefined
      ? unAnswered.push(document.getElementById(item.id))
      : item?.question?.type !== "COMPLEX_MULTIPLE_CHOICE" &&
          ((item?.question?.settings?.canComment && getAnswer(item.id).note === "") ||
            (item?.question?.settings?.canAttachPhoto && getAnswer(item.id).image?.length === 0))
        ? unAnswered.push(document.getElementById(item.id))
        : item?.question?.type === "COMPLEX_MULTIPLE_CHOICE" &&
            ((item?.question?.settings?.answers[getAnswer(item?.question.questionUuid)?.selected[0]?.index]?.canComment &&
              getAnswer(item.id).note === "") ||
              (item?.question?.settings?.answers[getAnswer(item?.question.questionUuid)?.selected[0]?.index]?.canAttachPhoto &&
                getAnswer(item.id).image?.length === 0))
          ? unAnswered.push(document.getElementById(item.id))
          : null;
  });
  return unAnswered[0];
};

export const numberFailHandler = (question, answerValue) => {
  if (answerValue && answerValue !== undefined) {
    if (question?.settings?.comparision === "More than") {
      if (answerValue > +question?.settings?.min) {
        return false;
      } else {
        return true;
      }
    } else if (question?.settings?.comparision === "More than or equals") {
      if (answerValue >= +question?.settings?.min) {
        return false;
      } else {
        return true;
      }
    } else if (question?.settings?.comparision === "Equals") {
      if (+answerValue === +question?.settings?.min) {
        return false;
      } else {
        return true;
      }
    } else if (question?.settings?.comparision === "Less than or equals") {
      if (answerValue <= +question?.settings?.max) {
        return false;
      } else {
        return true;
      }
    } else if (question?.settings?.comparision === "Less than") {
      if (answerValue < +question?.settings?.max) {
        return false;
      } else {
        return true;
      }
    } else if (question?.settings?.comparision === "Between") {
      if (answerValue >= +question?.settings?.min && answerValue <= +question?.settings?.max) {
        return false;
      } else {
        return true;
      }
    }
  } else {
    return false;
  }
};

export const canAccessTheModule = (roleSetting, module) => {
  if (roleSetting) {
    return <>{module}</>;
  } else {
    return false;
  }
};

export const canAccessTheTabs = (roleSetting, array) => {
  if (roleSetting) {
    return array;
  } else {
    return false;
  }
};

export const swapTwoValuesPositionInArray = (arr, position1, position2) => {
  let duplicateArray = [...arr];
  let temp = duplicateArray[position1];
  duplicateArray[position1] = duplicateArray[position2];
  duplicateArray[position2] = temp;
  return duplicateArray;
};

export const logoutUserWithNoAccess = (logout, history) => {
  logout();
  history.push("/login");
  toast.error(<I18n lng="global.YouDontHaveAnyAccess" />);
};

export const canAccessTheRoutes = (rolesAccess, logout, history) => {
  if (!rolesAccess?.company?.selected && window.location.pathname.includes("/management")) {
    if (rolesAccess?.form?.selected) {
      history.push("/forms/form-management");
    } else if (rolesAccess?.report?.selected) {
      history.push("/reports/my-reports");
    } else {
      history.push("/company-user-profile");
    }
  } else if (!rolesAccess?.report?.selected && window.location.pathname.includes("/reports")) {
    if (rolesAccess?.form?.selected) {
      history.push("/forms/form-management");
    } else if (rolesAccess?.company?.selected) {
      history.push("/management/info");
    } else {
      history.push("/company-user-profile");
    }
  } else if (!rolesAccess?.form?.selected && window.location.pathname.includes("/forms")) {
    if (rolesAccess?.report?.selected) {
      history.push("/reports/my-reports");
    } else if (rolesAccess?.company?.selected) {
      history.push("/management/info");
    } else {
      history.push("/company-user-profile");
    }
  }
};

export const floatOrIntegerNumber = (x) => {
  if (Number.isInteger(x)) {
    return false;
  } else {
    return true;
  }
};

export const jumpInputField = (e, index, cardNumber, setCardNumber) => {
  // changing the values
  let numbers = [...cardNumber];
  numbers[index] = e.target.value;
  setCardNumber([...numbers]);

  const { maxLength, value, name } = e.target;
  // eslint-disable-next-line
  const [fieldName, fieldIndex] = name.split("-");

  let fieldIntIndex = parseInt(fieldIndex, 10);

  // Check if no. of char in field === maxLength
  if (value.length >= maxLength) {
    // It should not be last input field
    if (fieldIntIndex < 4) {
      // Get the next input field using it's name
      const nextfield = document.querySelector(`input[name=field-${fieldIntIndex + 1}]`);

      // If found, focus the next field
      if (nextfield !== null) {
        nextfield.focus();
      }
    }
    // Check if no. of char in field === 0
  } else if (value.length === 0) {
    if (fieldIntIndex > 1) {
      // Get the previous input field using it's name
      const nextfield = document.querySelector(`input[name=field-${fieldIntIndex - 1}]`);

      // If found, focus the previous field
      if (nextfield !== null) {
        nextfield.focus();
      }
    }
  }
};

export const TEMPERATURE_CONDITION = (question) => {
  if (question?.settings?.comparision === "Less than") {
    return "(Range < " + question?.settings?.max + `${question?.settings?.measurement === "FAHRENHEIT" ? "˚F  " : "˚C "})`;
  } else if (question?.settings?.comparision === "Less than or equals") {
    return "(Range <= " + question?.settings?.max + `${question?.settings?.measurement === "FAHRENHEIT" ? "˚F  " : "˚C "})`;
  } else if (question?.settings?.comparision === "Equals") {
    return "(Range = " + question?.settings?.min + `${question?.settings?.measurement === "FAHRENHEIT" ? "˚F  " : "˚C "})`;
  } else if (question?.settings?.comparision === "More than or equals") {
    return "(Range >= " + question?.settings?.min + `${question?.settings?.measurement === "FAHRENHEIT" ? "˚F  " : "˚C "})`;
  } else if (question?.settings?.comparision === "More than") {
    return "(Range > " + question?.settings?.min + `${question?.settings?.measurement === "FAHRENHEIT" ? "˚F  " : "˚C "})`;
  } else if (question?.settings?.comparision === "Between") {
    return (
      "(Range > " +
      question?.settings?.min +
      " ~ " +
      question?.settings?.max +
      " < " +
      `${question?.settings?.measurement === "FAHRENHEIT" ? "˚F   " : "˚C "})`
    );
  }
};
export const NUMBER_CONDITION = (question) => {
  if (question?.settings?.comparision === "Less than") {
    return "(Range < " + question?.settings?.max + ")";
  } else if (question?.settings?.comparision === "Less than or equals") {
    return "(Range <= " + question?.settings?.max + ")";
  } else if (question?.settings?.comparision === "Equals") {
    return "(Range = " + question?.settings?.min + ")";
  } else if (question?.settings?.comparision === "More than or equals") {
    return "(Range >= " + question?.settings?.min + ")";
  } else if (question?.settings?.comparision === "More than") {
    return "(Range > " + question?.settings?.min + ")";
  } else if (question?.settings?.comparision === "Between") {
    return `(Range > ${question?.settings?.min} ~ ${question?.settings?.max} < )`;
  }
};

export const CAPITALIZE_FIRST_LETTER = (text) => {
  if (text !== "" && text !== undefined && text !== null) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  } else {
    return "";
  }
};

export const INVOICE_NUMBER_GENERATOR = (totalInvoices) => {
  let str = "" + totalInvoices;
  let pad = "000000";
  let number = pad.substring(0, pad.length - str.length) + str;
  return "A1-" + number;
};

export const INVOICE_AMOUNT_CALCULATOR = (invoiceDetailsToShow, tax) => {
  if (invoiceDetailsToShow?.cost && invoiceDetailsToShow?.totalUsers) {
    if (tax === undefined) {
      let subTotal = +invoiceDetailsToShow?.cost * +invoiceDetailsToShow?.totalUsers;
      return Number(subTotal).toFixed(2);
    } else {
      let tax = (+invoiceDetailsToShow?.cost * +invoiceDetailsToShow?.totalUsers * 15) / 100;
      let total = +invoiceDetailsToShow?.cost * +invoiceDetailsToShow?.totalUsers + tax;
      return Number(total).toFixed(2);
    }
  } else if (invoiceDetailsToShow && invoiceDetailsToShow?.totalSms) {
    if (tax === undefined) {
      let subTotal = invoiceDetailsToShow.totalSms * 0.04;
      return Number(subTotal).toFixed(2);
    } else {
      let tax = (+invoiceDetailsToShow?.totalSms * 0.04 * 15) / 100;
      let total = invoiceDetailsToShow.totalSms * 0.04 + tax;
      return Number(total).toFixed(2);
    }
  }
  return "";
};

export const PDF_IMAGE_CLASS = (number) => {
  let className = "";
  if (number && number !== undefined) {
    if (number !== 1 && number !== 2 && (number % 4 === 1 || number % 4 === 2)) {
      className = "pageBreak";
    }
  }
  return className;
};

export const TEXT_DIRECTION = () => {
  let direction = document.getElementsByTagName("html")[0].getAttribute("dir");
  return direction;
};

export const GET_USER_LOCATION = async (setLocation) => {
  if (window.navigator.geolocation) {
    window.navigator.geolocation.getCurrentPosition(
      (res) => {
        fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${res.coords.latitude},${res.coords.longitude}&key=AIzaSyBoV-vH2LdoFdgz5JR5fR-1HQ45wAeACPg`,
        )
          .then((res) => res.json())
          .then((res) => {
            let returnData = {
              address: "",
              city: "",
              country: "",
            };
            res.results.map((item, index) => {
              if (item.types && item.types.length) {
                if (item.types.includes("country")) {
                  returnData.country = item.address_components[0].long_name;
                } else if (item.types.includes("administrative_area_level_2")) {
                  returnData.city = item.address_components[0].long_name;
                }
              }
              if (index === 0) {
                returnData.address = item?.formatted_address;
                returnData.latitude = item?.geometry?.location?.lat;
                returnData.longitude = item?.geometry?.location?.lng;
              }
              return { ...returnData };
            });
            setLocation({ ...returnData });
          });
      },
      (err) => {
        if (err && err.message === "User denied Geolocation") {
          toast(i18n("validation.PleaseAllowLocationAccess"));
        }
      },
    );
  }
};

export const GET_LOCATION_BY_GEOCODE = async (latitude, longitude) => {
  try {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyBoV-vH2LdoFdgz5JR5fR-1HQ45wAeACPg`,
    );

    const res = await response.json();

    if (res.status !== "OK") {
      console.error("Geocoding API error:", res.status, res.error_message);
      return {
        address: "",
        city: "",
        country: "",
        latitude: latitude,
        longitude: longitude,
      };
    }

    if (!res.results || res.results.length === 0) {
      console.error("No results from Geocoding API");
      return {
        address: "",
        city: "",
        country: "",
        latitude: latitude,
        longitude: longitude,
      };
    }

    let returnData = {
      address: "",
      city: "",
      country: "",
      latitude: latitude,
      longitude: longitude,
    };

    returnData.address = res.results[0].formatted_address;

    for (const result of res.results) {
      if (result.address_components) {
        for (const component of result.address_components) {
          if (component.types.includes("country") && !returnData.country) {
            returnData.country = component.long_name;
          }
          if (component.types.includes("locality") && !returnData.city) {
            returnData.city = component.long_name;
          } else if (component.types.includes("administrative_area_level_2") && !returnData.city) {
            returnData.city = component.long_name;
          }
        }
      }

      if (returnData.city && returnData.country) {
        break;
      }
    }

    return returnData;
  } catch (error) {
    console.error("Error in GET_LOCATION_BY_GEOCODE:", error);
    return {
      address: "",
      city: "",
      country: "",
      latitude: latitude,
      longitude: longitude,
    };
  }
};

export const GET_WINDOW_DIMENSIONS = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const isRTL = (s) => {
  // eslint-disable-next-line
  var ltrChars = "A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF" + "\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF",
    rtlChars = "\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC",
    rtlDirCheck = new RegExp("^[^" + ltrChars + "]*[" + rtlChars + "]");

  return rtlDirCheck.test(s);
};

export const formAllAnswerdDetails = async (data) => {
  let formUnAnswerdDetail = [];
  let allImages = [];
  let newFormAnswerDetail = [];
  if (data.formDetail.schema.pages.length) {
    // eslint-disable-next-line
    data.formDetail.schema.pages.map((page) => {
      // eslint-disable-next-line
      page?.sections.map((section) => {
        // eslint-disable-next-line
        return section?.questions.map((question) => {
          const answer = data?.formAnswerDetail?.find((item) => item?.questionUuid === question.questionUuid);
          if (answer === undefined) {
            let submitedData;
            if (question.type === "COMPLEX_MULTIPLE_CHOICE") {
              submitedData = {
                questionUuid: question.questionUuid,
                selected: [],
                note: "",
                image: [],
              };
            }
            if (question.type === "number" || question.type === "text" || question.type === "date time" || question.type === "DROPDOWN") {
              submitedData = {
                questionUuid: question.questionUuid,
                value: "",
                note: "",
                image: [],
              };
            }
            if (question.type === "checkbox") {
              submitedData = {
                questionUuid: question.questionUuid,
                value: false,
                note: "",
                image: [],
              };
            }
            if (question.type === "pdf") {
              submitedData = {
                questionUuid: question.questionUuid,
                pdfPreview: "",
                pdfFileUrl: "",
                note: "",
                image: [],
              };
            }
            if (question.type === "slider") {
              submitedData = {
                questionUuid: question.questionUuid,
                sliderValue: "",
                note: "",
                image: [],
              };
            }
            if (question.type === "image") {
              submitedData = {
                questionUuid: question.questionUuid,
                inspectorImages: [],
                note: "",
                image: [],
              };
            }
            if (question.type === "location") {
              submitedData = {
                questionUuid: question.questionUuid,
                locationImage: "",
                note: "",
                image: [],
              };
            }
            if (question.type === "signature") {
              submitedData = {
                questionUuid: question.questionUuid,
                signatureImage: "",
                signatureName: "",
                note: "",
                image: [],
                signature: [],
              };
            }
            if (question.type === "instructions") {
              submitedData = {
                value: "",
              };
            }
            if (submitedData !== undefined) {
              formUnAnswerdDetail.push(submitedData);
            }
          }
        });
      });
    });
    let formAnswerDetail;
    if (formUnAnswerdDetail.length && data?.formAnswerDetail?.length) {
      formAnswerDetail = data.formAnswerDetail.concat(formUnAnswerdDetail);
    } else if (data?.formAnswerDetail?.length && formUnAnswerdDetail.length === 0) {
      formAnswerDetail = data.formAnswerDetail;
    } else if (formUnAnswerdDetail.length && (data?.formAnswerDetail?.length === 0 || data.formAnswerDetail === undefined)) {
      formAnswerDetail = formUnAnswerdDetail;
    }
    // eslint-disable-next-line
    formAnswerDetail?.map((answer) => {
      if (answer.image?.length || answer.inspectorImages?.length) {
        const imageQuestion = answer.inspectorImages?.map((item, index) => {
          allImages.push(index + 1);
          return { ...item, imageNumber: allImages?.length };
        });
        const image = answer.image.map((item, index) => {
          allImages.push(index + 1);
          return { ...item, imageNumber: allImages?.length };
        });
        let updatedAnswer = {
          ...answer,
          image: image,
          inspectorImages: imageQuestion,
        };
        newFormAnswerDetail.push(updatedAnswer);
      } else {
        newFormAnswerDetail.push(answer);
      }
    });
    return newFormAnswerDetail;
  }
};

export const IncludeStringInDropdownOrNot = (name) => {
  if (name === i18n("Analytics.Completion (%)")) {
    return i18n("Analytics.Completion");
  } else if (name === i18n("Analytics.Score (%)")) {
    return i18n("Analytics.Score");
  } else if (name === i18n("Analytics.Form")) {
    return i18n("Analytics.FormName");
  } else {
    return name;
  }
};

export const translateMonthsFromCharts = (item) => {
  if (!item.includes(":00")) {
    let month = item.slice(item.length - 3, item.length);
    let date = item.slice(0, item.indexOf(month));
    if (month === "Jan") {
      return i18n("Analytics.Jan") + date;
    } else if (month === "Feb") {
      return i18n("Analytics.Feb") + date;
    } else if (month === "Mar") {
      return i18n("Analytics.Mar") + date;
    } else if (month === "Apr") {
      return i18n("Analytics.Apr") + date;
    } else if (month === "May") {
      return i18n("Analytics.May") + date;
    } else if (month === "Jun") {
      return i18n("Analytics.Jun") + date;
    } else if (month === "Jul") {
      return i18n("Analytics.Jul") + date;
    } else if (month === "Aug") {
      return i18n("Analytics.Aug") + date;
    } else if (month === "Sep") {
      return i18n("Analytics.Sep") + date;
    } else if (month === "Oct") {
      return i18n("Analytics.Oct") + date;
    } else if (month === "Nov") {
      return i18n("Analytics.Nov") + date;
    } else if (month === "Dec") {
      return i18n("Analytics.Dec") + date;
    } else return month + date;
  } else {
    return item;
  }
};

export const translatePercentageFromCharts = (percentage) => {
  if (TEXT_DIRECTION() === "rtl") {
    return percentage.replace("%", "").replace("(", "(%");
  } else return percentage;
};

export const translateChartsValue = (value) => {
  let percentage = value.toString().split("").pop();
  let valueToAppend = value.toString().slice(0, value.toString().indexOf(percentage));
  if (TEXT_DIRECTION() === "rtl") {
    return percentage + valueToAppend;
  } else return value;
};

export const translateStatusForPDF = (status) => {
  if (status === "submit") {
    return TEXT_DIRECTION() === "ltr" ? i18n("Analytics.Submitted") : "مسلّم";
  } else if (status === "draft") {
    return TEXT_DIRECTION() === "ltr" ? i18n("Analytics.Draft") : "مسودة";
  } else if (status === "accept") {
    return TEXT_DIRECTION() === "ltr" ? i18n("Analytics.Complete") : "مكتمل";
  } else if (status === "incomplete") {
    return TEXT_DIRECTION() === "ltr" ? i18n("Analytics.Incomplete") : "غير مكتمل";
  } else if (status === "reSubmit") {
    return TEXT_DIRECTION() === "ltr" ? i18n("Reports.Resubmitted") : "معاد تسليمه";
  } else if (status === "reject") {
    return TEXT_DIRECTION() === "ltr" ? i18n("Analytics.Rejected") : "مرفوض";
  } else return status;
};

export const showHeaderHandler = (currentRoute, user) => {
  const activateLater = Storage.local.get("activate");
  if (user && !user.isEmailVerified && !activateLater) {
    return false;
  } else if (window?.location?.pathname?.includes("signup")) {
    return false;
  } else if (window?.location?.pathname?.includes("login")) {
    return false;
  } else if (window?.location?.pathname?.includes("password-reset-request")) {
    return false;
  } else if (window?.location?.pathname === "/") {
    return false;
  } else if (window?.location?.pathname?.includes("/homePage")) {
    return false;
  } else if (window?.location?.pathname?.includes("reset_password")) {
    return false;
  } else if (window?.location?.pathname?.includes("forms/form-management") && currentRoute.step1 === undefined && currentRoute.step2 === undefined) {
    return true;
  } else if (window?.location?.pathname?.includes("forms/form-management") && !user?.isEmailVerified && !activateLater) {
    return true;
  }
  return true;
};

// for trial end date
export const getBillingCycleDates = (plan, data) => {
  const endAtMoment = moment(data.subscriptionEndedAt);

  // if (!endAtMoment.isValid()) {
  //   throw new Error("Invalid endedAt date provided");
  // }

  // const startDate = moment(data.subscriptionStartedAt);
  const startDate = moment(data.subscriptionStartedAt).isBefore(moment(Date.now())) ? moment(Date.now()) : moment(data.subscriptionStartedAt);
  let endDate;
  if (plan !== data.currentPlan.plan) {
    if (plan === "Monthly Subscription") {
      endDate = endAtMoment.add(30.28, "days");
    } else if (plan === "Yearly Subscription") {
      endDate = endAtMoment.add(365.25, "days");
    } else {
      throw new Error("Invalid plan provided");
    }
  }
  if (data.subscriptionEndedAt === null || data.currentPlan.status === "Paused") {
    let startDate = moment();
    let endDate;
    if (plan === "Monthly Subscription") {
      endDate = startDate.clone().add(30, "days");
    } else if (plan === "Yearly Subscription") {
      endDate = startDate.clone().add(365, "days");
    } else {
      throw new Error("Invalid plan provided");
    }

    return `${startDate.format("MMM DD, YYYY")} - ${endDate.format("MMM DD, YYYY")}`;
  }

  if (endDate === undefined) {
    return `${startDate?.format("MMM DD, YYYY")} - ${endAtMoment?.format("MMM DD, YYYY")}`;
  } else {
    return `${moment(data.subscriptionEndedAt)?.format("MMM DD, YYYY")} - ${endDate?.format("MMM DD, YYYY")}`;
  }
};

// for subscription next billing date
// While a free trial is ACTIVE (isTrialStarted && !isTrialExpired &&
// !isTrialCancelled) the first charge is deferred to the trial-end date — the
// trial-end cron fires it then — so the next billing date is the trial
// EXPIRATION date (trialEndedAt), NOT subscriptionEndedAt. This holds whether
// or not the user has already subscribed mid-trial: when subscribing during an
// active trial the backend has not started the paid billing window, and
// subscriptionEndedAt carries the subscribe date (or is unset) — which made
// the card show the subscribe date / today. So we MUST gate on "trial active"
// and prefer trialEndedAt, NOT just check whether subscriptionEndedAt is set
// (a set-but-stale subscriptionEndedAt was the actual bug). For every non-
// active-trial state (paid Running, Paused, Expired, cancelled/expired trial)
// subscriptionEndedAt is the real renewal date and is used as before — no
// regression for accounts that are not in a free trial.
// Guard with `value && moment(value).isValid()` so a missing value short-
// circuits before moment(undefined) (which resolves to NOW) can leak through.
export const getNextBillingDate = ({ subscriptionData }) => {
  const trialEndedAt = subscriptionData?.trialEndedAt;
  const isTrialActive =
    subscriptionData?.userTrial?.isTrialStarted &&
    !subscriptionData?.userTrial?.isTrialExpired &&
    !subscriptionData?.userTrial?.isTrialCancelled;
  if (isTrialActive && trialEndedAt && moment(trialEndedAt).isValid()) {
    return moment(trialEndedAt).format("DD MMM YYYY");
  }
  const endedAt = subscriptionData?.subscriptionEndedAt;
  if (endedAt && moment(endedAt).isValid()) {
    return moment(endedAt).format("DD MMM YYYY");
  }
  // Last-resort fallback (subscriptionEndedAt unset and not an active trial):
  // prefer trial end if present, else a dash — never moment(undefined)===today.
  if (trialEndedAt && moment(trialEndedAt).isValid()) {
    return moment(trialEndedAt).format("DD MMM YYYY");
  }
  return "-";
};

const BookmarkedReports = ({ bookmarkedUsers }) => {
  const sortBookmarksByDate = (bookmarks) => {
    return [...bookmarks].sort((a, b) => new Date(b.bookmarkedAt) - new Date(a.bookmarkedAt));
  };
  const sortedBookmarks = sortBookmarksByDate(bookmarkedUsers);
  return (
    <div>
      {sortedBookmarks.map((bookmark) => (
        <div key={bookmark.userId}>
          <span>Bookmarked on: {new Date(bookmark.bookmarkedAt).toLocaleDateString()}</span>
        </div>
      ))}
    </div>
  );
};

export default BookmarkedReports;

export const getAssigneeIdsFromOtherRules = (allDispatchRules, ruleForEdit) => {
  const selectedIds = new Set();

  allDispatchRules.forEach((rule) => {
    if (rule !== ruleForEdit) {
      rule.assignees.forEach((assignee) => {
        selectedIds.add(assignee.id);
      });
    }
  });

  return selectedIds;
};

export const filterAvailableUsers = (users, selectedIds, ruleForEdit) => {
  return users.filter((user) => !selectedIds.has(user.id) || ruleForEdit?.assignees.some((assignee) => assignee.id === user.id));
};
export const getCompleteUserLocation = async () => {
  return new Promise((resolve) => {
    if (!window.navigator.geolocation) {
      console.warn("Geolocation not supported");
      getLocationByIP().then((ipLocation) => {
        resolve(
          ipLocation || {
            address: "",
            city: "",
            country: "",
            latitude: "",
            longitude: "",
          },
        );
      });
      return;
    }

    window.navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;

          // Try Google Geocoding API FIRST (most accurate for your area)
          const locationData = await GET_LOCATION_BY_GEOCODE(latitude, longitude);

          if (locationData && locationData.address) {
            resolve({
              address: locationData.address,
              city: locationData.city || "",
              country: locationData.country || "",
              latitude: latitude,
              longitude: longitude,
            });
            return; // Success - exit early
          }

          // Fallback to OpenStreetMap only if Google fails
          try {
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`,
              {
                headers: {
                  "User-Agent": "TamamApp/1.0",
                },
              },
            );
            const data = await response.json();

            if (data && data.display_name) {
              let city = "";
              if (data.address) {
                city = data.address.city || data.address.town || data.address.suburb || data.address.neighbourhood || data.address.village || "";
              }

              resolve({
                address: data.display_name,
                city: city,
                country: data.address?.country || "",
                latitude: latitude,
                longitude: longitude,
              });
              return;
            }
          } catch (osmError) {
            console.error("OpenStreetMap error:", osmError);
          }

          // Last resort: IP-based location
          const ipLocation = await getLocationByIP();
          resolve(
            ipLocation || {
              address: `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`,
              city: "",
              country: "",
              latitude: latitude,
              longitude: longitude,
            },
          );
        } catch (error) {
          console.error("Error getting location:", error);
          const ipLocation = await getLocationByIP();
          resolve(
            ipLocation || {
              address: "",
              city: "",
              country: "",
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            },
          );
        }
      },
      async (error) => {
        console.warn("Browser geolocation error:", error.message);
        const ipLocation = await getLocationByIP();
        resolve(
          ipLocation || {
            address: "",
            city: "",
            country: "",
            latitude: "",
            longitude: "",
          },
        );
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      },
    );
  });
};

// Helper function to get address from coordinates using Google Geocoding
// const getAddressFromCoordinates = async (latitude, longitude) => {
//   try {
//     const apiKey = "AIzaSyBoV-vH2LdoFdgz5JR5fR-1HQ45wAeACPg";
//     const response = await fetch(
//       `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
//     );
//     const data = await response.json();

//     if (data.status === "OK" && data.results && data.results.length > 0) {
//       const result = data.results[0];
//       const locationData = {
//         address: result.formatted_address || "",
//         city: "",
//         country: "",
//         latitude,
//         longitude,
//       };

//       // Extract city and country from address components
//       for (const component of result.address_components) {
//         if (component.types.includes("locality") ||
//           component.types.includes("sublocality") ||
//           component.types.includes("administrative_area_level_2")) {
//           locationData.city = component.long_name;
//         }
//         if (component.types.includes("country")) {
//           locationData.country = component.long_name;
//         }
//       }

//       return locationData;
//     } else {
//       console.warn("Google Geocoding API error:", data.status);
//       // Return basic location data if geocoding fails
//       return {
//         address: "",
//         city: "",
//         country: "",
//         latitude,
//         longitude,
//       };
//     }
//   } catch (error) {
//     console.error("Error with Google Geocoding:", error);
//     return {
//       address: "",
//       city: "",
//       country: "",
//       latitude,
//       longitude,
//     };
//   }
// };

// Keep your existing IP location function
const getLocationByIP = async () => {
  try {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();

    if (data && !data.error) {
      return {
        address: `${data.city}, ${data.region}, ${data.country_name}`,
        city: data.city || "",
        country: data.country_name || "",
        latitude: data.latitude,
        longitude: data.longitude,
      };
    }
    return null;
  } catch (error) {
    console.error("Error getting IP-based location:", error);
    return null;
  }
};

export const reportHistoryStatusTranslations = (text) => {
  if (text === "draft") {
    return i18n("Table.Draft");
  } else if (text === "incomplete") {
    return i18n("Table.InComplete");
  } else if (text === "reSubmit") {
    return i18n("Table.reSubmit");
  } else if (text === "reject") {
    return i18n("Table.reject");
  } else if (text === "accept") {
    return i18n("Table.accept");
  } else if (text === "submit") {
    return i18n("Table.submit");
  }
};

export const translateHomeHeaderContent = (text, lng) => {
  if (lng === "ARABIC") {
    if (text === "Features") {
      return "الميزات";
    } else if (text === "Terms and Conditions") {
      return "شروط و احكام";
    } else if (text === "Privacy Policy") {
      return "سياسة الخصوصية";
    } else if (text === "Industries") {
      return "القطاعات";
    } else if (text === "Prices") {
      return "الأسعار";
    } else if (text === "Contact") {
      return "تواصل معنا";
    } else if (text === "Log in") {
      return "الدخول";
    } else if (text === "START FOR FREE") {
      return "إبدأ مجاناً";
    } else if (text === "GET STARTED FOR FREE") {
      return "إبدأ الإستخدام مجاناً";
    } else if (text === "Help") {
      return "المساعدة";
    } else if (text === "Contact Us") {
      return "تواصل معنا";
    } else if (text === "Saudi Arabia") {
      return "المملكة العربية السعودية";
    } else if (text === "©Tamam 2026 by Numu Information Technology") {
      return "©تمام 2026  بواسطة نمو لتقنية المعلومات";
    } else if (text === "Last Updated") {
      return " آخر تحديث";
    } else {
      return text;
    }
  } else return text;
};

export const verifyAccountTranslation = (text, language) => {
  return text === "InvalidCodeHasExpired"
    ? language === "ARABIC"
      ? "رمز غير صالح أو انتهت صلاحية الرمز"
      : "Invalid code or the code has expired"
    : text === "ActivateAccount"
      ? language === "ARABIC"
        ? "تفعيل حسابك"
        : "Activate your Account"
      : text === "WehaveSentAVerificationCodeToYourEmail"
        ? language === "ARABIC"
          ? "تم إرسال رمز التحقق إلى بريدك الإلكتروني. ,قم بالتحقق منه الآن لتأمين حسابك والحصول على مزايا تمام الكاملة."
          : "A verification code has been sent to your email. Verify it now to secure your account and unlock full Tamam benefits."
        : text === "Verify"
          ? language === "ARABIC"
            ? "تحقق"
            : "Verify"
          : text === "Resend"
            ? language === "ARABIC"
              ? "إعادة إرسال"
              : "Resend"
            : text === "Skip"
              ? language === "ARABIC"
                ? "تخطي"
                : "Skip"
              : text === "DidntReceivedTheCodeYet"
                ? language === "ARABIC"
                  ? "لم تتلق الرمز بعد؟"
                  : "Didn't receive a code yet?"
                : text === "InvalidCodeHasExpired"
                  ? language === "ARABIC"
                    ? "رمز غير صالح أو انتهت صلاحية الرمز"
                    : "Invalid code or the code has expired"
                  : "";
};
